<div class="app-shell">
  <app-header></app-header>
  <aside class="sidebar-wrap">
    <app-sidebar></app-sidebar>
  </aside>
  <main class="page">
    <div class="page-inner">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
